import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
function useUncontrolled(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    finalValue = _ref.finalValue,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _useState = useState(defaultValue !== void 0 ? defaultValue : finalValue),
    _useState2 = _slicedToArray(_useState, 2),
    uncontrolledValue = _useState2[0],
    setUncontrolledValue = _useState2[1];
  var handleUncontrolledChange = function handleUncontrolledChange(val) {
    setUncontrolledValue(val);
    onChange == null ? void 0 : onChange(val);
  };
  if (value !== void 0) {
    return [value, onChange, true];
  }
  return [uncontrolledValue, handleUncontrolledChange, false];
}
export { useUncontrolled };